import moment from 'moment-timezone'

export const MELBOURNE_TIMEZONE = 'Australia/Melbourne'
export const NEW_YORK_TIMEZONE = 'America/New_York'
export const US_COUNTRY_REGION = 'US'

export const currentMelbourneMoment = () => moment().tz(MELBOURNE_TIMEZONE)

export const currentMelbourneDate = () =>
  currentMelbourneMoment().format('YYYY-MM-DD')

export const currentBusinessMoment = (tenantCountryRegion) =>
  String(tenantCountryRegion || '').toUpperCase() === US_COUNTRY_REGION
    ? moment().tz(NEW_YORK_TIMEZONE)
    : currentMelbourneMoment()

export const currentBusinessDate = (tenantCountryRegion) =>
  currentBusinessMoment(tenantCountryRegion).format('YYYY-MM-DD')

export const minAllowedPromotionStartDate = (tenantCountryRegion) => {
  if (String(tenantCountryRegion || '').toUpperCase() === US_COUNTRY_REGION) {
    const now = currentBusinessMoment(tenantCountryRegion)
    const cutoff = now.clone().hour(10).minute(0).second(0).millisecond(0)

    if (now.isBefore(cutoff)) {
      return now.format('YYYY-MM-DD')
    }

    return now.clone().add(1, 'day').format('YYYY-MM-DD')
  }

  const now = currentMelbourneMoment()
  const cutoff = now.clone().hour(15).minute(0).second(0).millisecond(0)

  if (now.isBefore(cutoff)) {
    return now.format('YYYY-MM-DD')
  }

  return now.clone().add(1, 'day').format('YYYY-MM-DD')
}

export const minAllowedPromotionEndDate = (startDate, tenantCountryRegion) => {
  const currentDate = currentBusinessDate(tenantCountryRegion)

  return startDate && moment(startDate).isAfter(currentDate, 'day')
    ? startDate
    : currentDate
}
